import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { KVAnnotation, KVInspectionArea, RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

interface Vertex {
  vertexPosition: string
  vertexNormal: string
}

export function getInspectionAreaUpdatedMessage() {
  return {
    type: 'inspectionAreaUpdated',
    requiredData: ['inspectionAreaId'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const targetId = json.inspectionAreaId as string
      if (!targetId) return

      const list = kv.inspectionAreas ?? []
      const inspectionArea = list.find((ia) => ia.id === targetId)
      if (!inspectionArea) return

      // Update all fields from the incoming data
      if (json.inspectionAreaLabel !== undefined)
        inspectionArea.label = json.inspectionAreaLabel as string
      if (json.inspectionAreaNotes !== undefined)
        inspectionArea.notes = json.inspectionAreaNotes as string
      if (json.inspectionAreaStatus !== undefined)
        inspectionArea.status = json.inspectionAreaStatus as string
      if (json.inspectionAreaSeverity !== undefined)
        inspectionArea.severity = json.inspectionAreaSeverity as string
      if (json.inspectionAreaVisible !== undefined)
        inspectionArea.visible = json.inspectionAreaVisible as boolean
      if (json.inspectionAreaFillVisible !== undefined)
        inspectionArea.fillVisible = json.inspectionAreaFillVisible as boolean
      if (json.inspectionAreaPerimeterVisible !== undefined)
        inspectionArea.perimeterVisible =
          json.inspectionAreaPerimeterVisible as boolean
      if (json.inspectionAreaVertices)
        inspectionArea.vertices = json.inspectionAreaVertices as Vertex[]

      // Commit state update with a new array reference to ensure UI updates
      kv.setInspectionAreas([...(kv.inspectionAreas ?? [])])

      const data: Record<string, unknown> = {
        inspectionAreas:
          kv.inspectionAreas?.map((ia) => KVInspectionArea.toJSON(ia)) ?? [],
      }

      let annotations = kv.annotations ? [...kv.annotations] : undefined
      if (annotations && json.annotationToInspectionArea) {
        const annotationToInspectionArea: Record<
          string,
          Record<string, string>
        > = (json.annotationToInspectionArea || {}) as Record<
          string,
          Record<string, string>
        >

        annotations = annotations.map((annotation) => {
          if (annotationToInspectionArea[annotation.id]) {
            annotation.tags['inspectionArea'] = {
              derivedTag: true,
              value:
                annotationToInspectionArea[annotation.id].inspectionArea || '',
            }
          }

          return annotation
        })

        kv.setAnnotations(annotations)
        data['annotations'] = annotations.map((a) => KVAnnotation.toJSON(a))
      }

      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data,
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
